export default "__VITE_ASSET__BSP$czye__"